import ApiService from "./ApiService";
import { StorageService } from "./StorageService";

const distributionService = {
    getByDate(date) {
        const userId = StorageService.getUserData().id;
        date = date || "";
        return ApiService.get(`/distribution?date=${date}&userId=${userId}`);
    },
    getPendingByDate(date) {
        const providerId = StorageService.getUserData().providerId;
        date = date || "";
        return ApiService.get(
            `/distribution/pending?date=${date}&providerId=${providerId}`
        );
    },
    sendCheckOut(barCode, userId, date) {
        barCode = barCode || "";
        return ApiService.post("/distribution/check-out", {
            barCode,
            userId,
            date
        });
    },
    gemerateDocument(date, orderProviderdocument) {
        const providerId = StorageService.getUserData().providerId;
        return ApiService.post("/distribution/check-out-doc", {
            date,
            providerId,
            orderProviderdocument
        });
    },
    uploadOrder(date, consecutive) {
        const providerId = StorageService.getUserData().providerId;
        return ApiService.post("/distribution/upload-order", {
            date,
            consecutive,
            providerId
        });
    },
    downloadDoc(id) {
        return ApiService.customRequest({
            url: `${process.env.VUE_APP_ROOT_API}/distribution/download-doc/`,
            method: "post",
            data: {
                id
            }
        });
    }
};

export default distributionService;